import { render, staticRenderFns } from "./CandidatesHeaders.vue?vue&type=template&id=0664e720&scoped=true&lang=pug&"
import script from "./CandidatesHeaders.vue?vue&type=script&lang=js&"
export * from "./CandidatesHeaders.vue?vue&type=script&lang=js&"
import style0 from "./CandidatesHeaders.vue?vue&type=style&index=0&id=0664e720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0664e720",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
